import { defineTracking } from 'utils/googleAnalytics/defineTracking';

const category = 'landing page - success story';

export default {
    ...defineTracking({
        clickOnDiscoverHowButton: {
            category,
            action: 'click on success story',
            label: 'discover how button clicked',
            description:
                'This event triggered when user clicks on the discover how button on the success story banner.',
        },
    }),
};
